import { Table, TableColumnsType } from "antd";
import _ from "lodash";
import moment from "moment";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getDtttStudents } from "../../../api/statistics.api";
import useAxios from "../../../hooks/useAxios";
import config from "../../../lib/config";
import exportTable from "../../../lib/exportTable";
import { IDtttStudent, IGetDtttStudents } from "../../../models/statistics.model";
import { RootState } from "../../../store/rootReducer";
import DownloadButton from "../../DownloadButton";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import Pagination from "../../Pagination";

interface IProps {
  res: any;
  pageNo: number;
  setPageNo: (pageNo: number) => void;
  semesterCode: number|undefined;
  courseCode: string|undefined;
  pondTypeCode: string|undefined;
}

const List: FC<IProps> = ({
  res,
  pageNo,
  setPageNo,
  semesterCode,
  courseCode,
  pondTypeCode,
}) => {
  const { t } = useTranslation();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetDtttStudents>();
  const [resData, setResData] = useState<IDtttStudent[]>([]);

  useEffect(() => {
    if (res?.data) {
      const newData: any = _.cloneDeep(res?.data);
      
      newData.forEach((item: any, idx: number) => {
        item.rowKey = idx;
        item.planDate = moment(item.planDate).format('YYYY.MM.DD');
        item.score = item.score === null ? '-' : item.score;
      });

      setResData(newData);
    }
  }, [res]);

  useEffect(() => {
    if (res2 && !isLoading2) {
      const _data: any = _.cloneDeep(res2?.data);

      _data.forEach((item: any, idx: number) => {
        item.planDate = moment(item.planDate).format('YYYY.MM.DD');
        item.score = item.score === null ? '-' : item.score;
      });

      const currentDate = moment(new Date());
      exportTable(columns, _data, `${t('statistics.dttt.title1')}(${t('statistics.homework.tab1')})_(${currentDate.format('YYYYMMDD')})`, `${t('statistics.homework.tab1')}`, [12, 10, 20, 20, 10, 20, 12, 20, 15, 10, 10]);
    }
  }, [res2, isLoading2]);

  const onExportTable = () => {
    if (!semesterCode) return;

    execute2(getDtttStudents({
      semesterCode,
      courseCode,
      campusCode: currentCampus,
      perPage: 999999999,
      pageNo: 1,
      pondTypeCode
    }));
  }

  const columns: TableColumnsType<IDtttStudent> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusKorName',
      key: 'campusKorName',
      align: 'center',
    },
    {
      title: t('student.student.column5'),
      dataIndex: 'memberKorName',
      key: 'memberKorName',
      align: 'center',
    },
    {
      title: t('auth.login.label1'),
      dataIndex: 'webId',
      key: 'webId',
      align: 'center',      
    },
    {
      title: t('student.student.column64'),
      dataIndex: 'memberCode',
      key: 'memberCode',
      align: 'center',
    },
    {
      title: t('sms.list.column2'),
      dataIndex: 'typeName',
      key: 'typeName',
      align: 'center',
    },
    {
      title: 'Activity',
      dataIndex: 'activityName',
      key: 'activityName',
      align: 'center',
    },
    {
      title: t('statistics.dttt.column1'),
      dataIndex: 'courseName',
      key: 'courseName',
      align: 'center',
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      align: 'center',
    },
    {
      title: t('statistics.dttt.column3'),
      dataIndex: 'planDate',
      key: 'planDate',
      align: 'center',
    },
    {
      title: t('statistics.dttt.column4'),
      dataIndex: 'completeYn',
      align: 'center',
    },
    {
      title: t('common.column.score'),
      dataIndex: 'score',
      align: 'center',
    },
  ];

  return (
    <>
      {isLoading2 && <Loader />}
      <ErrorResponse error={error2} />

      <div className="comm-bx__between">
        <div className="comm-sch_result">
          Total: {<b>{res?.total}</b>}
        </div>
      </div>
      <div className="comm-table__area">
        <Table
          columns={columns}
          dataSource={resData}
          pagination={{
            current: pageNo,
            pageSize: config.pageSize,
          }}
          rowKey='rowKey'
        />
      </div>
      <div className="comm-bx__between">
        <DownloadButton onClick={onExportTable} />        
        <div className="common-paging center">
          <Pagination
            count={res?.total || 0}
            page={pageNo}
            setPage={setPageNo}
          />
        </div>
      </div>
    </>
  );
}

export default List;
